var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import isViablePhoneNumber from './isViablePhoneNumber';

// https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */
export function parseRFC3966(text) {
	var number = void 0;
	var ext = void 0;

	// Replace "tel:" with "tel=" for parsing convenience.
	text = text.replace(/^tel:/, 'tel=');

	for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var part = _ref;

		var _part$split = part.split('='),
		    _part$split2 = _slicedToArray(_part$split, 2),
		    name = _part$split2[0],
		    value = _part$split2[1];

		switch (name) {
			case 'tel':
				number = value;
				break;
			case 'ext':
				ext = value;
				break;
			case 'phone-context':
				// Only "country contexts" are supported.
				// "Domain contexts" are ignored.
				if (value[0] === '+') {
					number = value + number;
				}
				break;
		}
	}

	// If the phone number is not viable, then abort.
	if (!isViablePhoneNumber(number)) {
		return {};
	}

	var result = { number: number };
	if (ext) {
		result.ext = ext;
	}
	return result;
}

/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */
export function formatRFC3966(_ref2) {
	var number = _ref2.number,
	    ext = _ref2.ext;

	if (!number) {
		return '';
	}

	if (number[0] !== '+') {
		throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
	}

	return 'tel:' + number + (ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/libphonenumber-js/es6/RFC3966.js
// module id = ../../../../libphonenumber-js/es6/RFC3966.js
// module chunks = 3